import React, { useRef, useEffect, useState } from "react";
import { shallowEqual, useSelector, connect, useDispatch } from "react-redux";
import { LayoutSplashScreen } from "../../../context/LayoutContext";
import * as auth from "./authRedux";
import { getUserByToken } from "./authCrud";
import { useLocation } from "react-router-dom";
import queryString from "query-string";

function AuthInit(props) {
  const didRequest = useRef(false);
  const dispatch = useDispatch();
  const [showSplashScreen, setShowSplashScreen] = useState(true);
  const [orgnizationCodeLoading, setOrgnizationCodeLoading] = useState(false);
  const location = useLocation();
  const {
    token,
    practice_id,
    init_load,
    organization_code = null,
  } = queryString.parse(location.search);

  const { authToken, practiceId } = useSelector(
    ({ auth }) => ({
      authToken: auth && auth.authToken,
      practiceId: auth && auth.practice_id,
    }),
    shallowEqual
  );

  // useEffect(() => {
  //   if (organization_code) {
  //     localStorage.setItem("organization_code", organization_code);
  //   } else if (token) {
  //     localStorage.removeItem("organization_code");
  //   }
  //   setOrgnizationCodeLoading(false);
  // }, [organization_code]);

  // We should request user by authToken before rendering the application
  useEffect(() => {
    const requestUser = async (token) => {
      try {
        if (!didRequest.current) {
          const {
            data: {
              response: {
                data: { User },
              },
            },
          } = await getUserByToken(token, init_load);

          dispatch(props.fulfillUser(User, practice_id || practiceId));
        }
      } catch (error) {
        if (!didRequest.current) {
          dispatch(props.logout());
        }
      } finally {
        setShowSplashScreen(false);
      }

      return () => (didRequest.current = true);
    };

    if ((authToken || token) && !orgnizationCodeLoading) {
      dispatch(props.login(token || authToken));
      requestUser(token || authToken);
    }
  }, [token, authToken, practiceId, practice_id, orgnizationCodeLoading]);

  useEffect(() => {
    if (!authToken && !token) {
      dispatch(props.fulfillUser(undefined));
      setShowSplashScreen(false);
    }
  }, [token, authToken]);
  return showSplashScreen ? <LayoutSplashScreen /> : <>{props.children}</>;
}

export default connect(null, auth.actions)(AuthInit);
